import React, { useLayoutEffect } from "react";
import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";

import Api from "../../api";
import { ProjectExamples } from "../../includes";
import SeoBlock from "../../components/seo_block/SeoBlock";
import { MainSlider } from "../../components/main_slider";
import {
  ServiceLink,
  Customers,
} from "../../components";
import { Section } from "../../layouts";
import { useCorrectCustomers } from "../../hooks";
import Showreel from "../../components/showreel/Showreel";
import { reloadPage } from "../../utils";

const Main = ({  contact }) => {

  const [{ data }] = useAxios({ url: Api.home });

  const correctCustomers = useCorrectCustomers(data?.customers);
  const seo = data ? data.seo : {};
  const showreel = data && data.showreel && (
    <Showreel showreel={data.showreel} />
  );

  const services_list =
    data &&
    data.services.length > 0 &&
    data.services.map((item) => {
      return (
        <ServiceLink
          key={item.id}
          to={`/services/${item.slug}`}
          title={item.title}
          description={item.description}
        />
      );
    });

  const slides = data && data.slides;
  
  useLayoutEffect(function redirectToRubyPage() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // window.location.replace(`http://localhost:3001${window.location.pathname}`);
    } else {
      // window.history.pushState('service_react', '', window.location.pathname);
      // window.history.back();
      reloadPage();
    }
  });

  return (
    <div className="app main-container">
      <SeoBlock data={seo} contact={contact} />

      {slides && (
        <div
          className="wrap holder no-pdn-top"
          style={{
            height: "100%",
          }}
        >
          <MainSlider slides={slides} showBtn={false} />
        </div>
      )}

      {services_list && (
        <Section className="section section_small-mt">
          <div className="services-list">
            {services_list}

            <ServiceLink
              key={3435}
              to={`/produce`}
              title="Производственникам"
              description="Активно работаем с&nbsp;производственными предприятиями со&nbsp;всей России, создавая комплексные решения для развития."
            />
          </div>
        </Section>
      )}

      {data?.projects.length > 0 && (
        <Section className="section">
          <ProjectExamples
            isSmallTitleMargin
            projects={data?.projects}
            title="Наши проекты"
          />
        </Section>
      )}

      {showreel}

      {correctCustomers?.length > 0 && (
        <section className="section">
          <div className="wrap holder no-pdn-top">
            <Customers
              customers={data.customers}
              className="customer-list-outside"
            />
          </div>
        </section>
      )}
    </div>
  );
};

export default Main;
